import { DefaultCreditCard, FetchDefaultCreditCardRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchDefaultCreditCard() {
  const [fetching, setFetching] = useState(false);
  const [defaultOperationalCreditCard, setDefaultOperationalCreditCard] = useState<DefaultCreditCard | null>(null);

  async function fetchDefaultCreditCard(params: FetchDefaultCreditCardRequest = {}) {
    try {
      setFetching(true);
      const res = await api.fetchDefaultCreditCard(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setDefaultOperationalCreditCard(res.DefaultOperationalCreditCard);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return {
    fetching,
    defaultOperationalCreditCard,
    fetchDefaultCreditCard,
  };
}
